<router-outlet [hidden]="true"></router-outlet>
<app-loader *ngIf="showLoader" class="loader-center"></app-loader>
